/*
 * Copyright Innov'ATM all rights reserved.
 * This software is the property of Innov'ATM and may not be used in any manner except under a
 * license agreement signed with Innov'ATM.
 */

export function getKeycloakAdminUrl(): string {
    const url = new URL(import.meta.env.VITE_OIDC_ISSUER || '');
    const pathParts = url.pathname.split('/').filter(Boolean); // remove empty segments;
    const realmIndex = pathParts.indexOf('realms');

    if (realmIndex === -1 || realmIndex + 1 >= pathParts.length) {
        throw new Error('Invalid issuer URL format');
    }

    const realm = pathParts[realmIndex + 1];
    const basePath = pathParts.slice(0, realmIndex).join('/'); // take everything before 'realms'

    return `${url.origin}/${basePath ? basePath + '/' : ''}admin/${realm}/console/#/${realm}/users`;
}
